export default class GtmTracker {
  constructor() {
    this.dataLayer = window.dataLayer || [];
  }

  click(data) {
    console.log('Enhanced Ecom - Click: ', data);

    this.dataLayer.push({
      event: 'eec.click',
      ecommerce: data,
    });
  }

  add(data) {
    console.log('Enhanced Ecom - Add: ', data);
    this.dataLayer.push({
      event: 'eec.addToCart',
      ecommerce: data,
    });
  }

  remove(data) {
    console.log('Enhanced Ecom - Remove: ', data);
    this.dataLayer.push({
      event: 'eec.removeFromCart',
      ecommerce: data,
    });
  }

  impressions(data) {
      console.log('Enhanced Ecom - Impressions: ', data);
    this.dataLayer.push({
      event: 'eec.impressions',
      ecommerce: data,
    });
  }

  checkout(data) {
    console.log('Enhanced Ecom - Checkout:', data);
    this.dataLayer.push({
      event: 'eec.checkout',
      ecommerce: data,
    });
  }

  purchase(data, customer = '') {
    console.log('Enhanced Ecom - Purchase: ', data);
    this.dataLayer.push({
      event: 'eec.purchase',
      customer,
      ecommerce: data,
    });
  }

  details(data) {
    console.log('Enhanced Ecom - Details: ', data);
    this.dataLayer.push({
      event: 'eec.detail',
      ecommerce: data,
    });
  }
}
